import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Externally_Service_Form from "./externally_Service_Form/Externally_Service_Form";
import Externally_Service_table from "./externally_Service_table/Externally_Service_table";

function Externally_Service() {
  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Externally Service" />
        </div>
       

        <div className="imperiality_Form_div">
          <Externally_Service_Form />
        </div>

        <div className="imperiality_table_div">
          <Externally_Service_table />
        </div>

       
      </section>
    </>
  );
}

export default Externally_Service;
